import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, IconButton, TextField, Box, Menu, MenuItem, Avatar, Typography, Divider } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import PaymentIcon from '@mui/icons-material/Payment';
import LogoutIcon from '@mui/icons-material/Logout';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import NotificationsIcon from '@mui/icons-material/Notifications';
import HomeIcon from '@mui/icons-material/Home';
import SchoolIcon from '@mui/icons-material/School';
import Logo from '../Logo/Dark/Full - Copy/1Asset 17@72x-8.png';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

function Header3({ userId, onLogout}) {
 
    const [searchQuery, setSearchQuery] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const dropdownRef = useRef();
    const [userData, setUserData] = useState({
        "name": "",
        "about": "",
        "address": "",
        "contact": "",
        "created_at": "",
        "dob": "",
        "email": "",
        "gender": "",
        "id": "",
        "image": "",
        "languages": "",
        "password": "",
        "rating": "",
        "role": "",
        "status": "",
        "surname": "",
        "updated_at": ""
    });  // State to store fetched user data


    const getRandomColor = () => {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };


    const randomColor = getRandomColor();





    useEffect(() => {
        if (!userId) {
            return;
        }

        // Axios request to fetch user data
        axios
            .get(`${API_URL}/get_user_data/?user_id=${userId}`)
            .then((response) => {
                setUserData(response.data);
            })
            .catch((err) => {
                console.error(err);
            });
    }, [userId]);

    const handleClear = () => setSearchQuery('');

    const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);



    return (
        <Box>
            {/* Header AppBar */}
            <AppBar
                position="fixed"
                sx={{
                    bgcolor: 'black',
                    color: 'white',
                    zIndex: 1100, // Ensure this AppBar is on top
                }}
            >
                <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {/* Logo */}
                    <Link to="/home">
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                transition: 'transform 0.3s',
                                mr: 1,
                                '&:hover': {
                                    transform: 'scale(1.1)',
                                },
                            }}
                        >
                            <img
                                src={Logo}
                                alt="Logo"
                                style={{ width: '120px', height: 'auto', maxWidth: '100%' }}
                            />
                        </Box>
                    </Link>


                    {/* Navigation Icons */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <IconButton component={Link} to={`/platform/${userId}`} color="inherit">
                            <HomeIcon />
                        </IconButton>
                        {/* <IconButton component={Link} to={`/notifications/${userId}`} color="inherit">
                            <NotificationsIcon />
                        </IconButton> */}
                        <IconButton component={Link} to={`/Documentation`} color="inherit">
                            <SchoolIcon />
                        </IconButton>

                        <IconButton component={Link} to={`/admin-panel/${userId}`} color="inherit">
                            <PersonIcon sx={{ color: '#FF6347' }} />
                        </IconButton>

                        {/* User Profile Dropdown */}
                        <IconButton onClick={handleMenuOpen} ref={dropdownRef} color="inherit">
                            <Avatar sx={{ bgcolor: randomColor, width: 48, height: 48 }}>
                                {userData.name ? userData.name[0] : ''} {userData.surname ? userData.surname[0] : ''}
                            </Avatar>
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                            PaperProps={{
                                style: {
                                    width: 200,
                                },
                                sx: {
                                    bgcolor: '#0e0e0e', // Darker background
                                    color: 'white', // White text
                                    border: '1px solid #333',
                                    borderRadius: 3,
                                    boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.8)',
                                },
                            }}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right', // Align dropdown to the right of the anchor
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right', // Ensure the dropdown opens from the right
                            }}
                        >
                            {/* Profile Section */}
                            <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2, bgcolor: '#1a1a1a', borderRadius: '6px 6px 0 0' }}>
                                <Box>
                                    <Typography variant="h6" component="h1" sx={{ fontWeight: 'bold', color: '#E1E1E1' }}>
                                        {userData.name} {userData.surname}
                                    </Typography>
                                </Box>
                            </Box>
                            <Divider sx={{ bgcolor: '#333' }} />

                            {/* Dropdown Options */}
                            <MenuItem
                                component={Link}
                                to={`/UserProfile/${userId}`}
                                onClick={handleMenuClose}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 2,
                                    py: 1.5,
                                    '&:hover': { bgcolor: '#2a2a2a' },
                                }}
                            >
                                <PersonIcon sx={{ color: '#1E90FF' }} />
                                <Typography>User Details</Typography>
                            </MenuItem>
                            <MenuItem
                                component={Link}
                                to={`/subscriptions?userId=${userId}`}
                                onClick={handleMenuClose}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 2,
                                    py: 1.5,
                                    '&:hover': { bgcolor: '#2a2a2a' },
                                }}
                            >
                                <PaymentIcon sx={{ color: '#1E90FF' }} />
                                <Typography>Subscription</Typography>
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    handleMenuClose();
                                    onLogout();
                                }}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 2,
                                    py: 1.5,
                                    '&:hover': { bgcolor: '#2a2a2a' },
                                }}
                            >
                                <LogoutIcon sx={{ color: '#1E90FF' }} />
                                <Typography>Logout</Typography>
                            </MenuItem>
                        </Menu>
                    </Box>
                </Toolbar>
            </AppBar>
        </Box>

    );
}

export default Header3;
